export class Assurees {
  //Cette classe est utilisée dans le Backend du site de souscription en ligne
  assurePrincipal!: AssurePrincipal;
  isConjoint!: boolean;
  assureConjoint!: AssureConjoint | any;
  isEnfants!: boolean;
  assureEnfants!: AssureEnfant[];
  dateEffet!: string;
  telaRappeler!: string;
  eMailRecontacte!: string;
  paysNaissance!: string;
  ville: string;
  guidUser?: string;
  pwdUser?: string;
  addressAssuree!: string;
  addressComplement!: string;
  constructor(
    assurePrincipal: AssurePrincipal,
    isConjoint: boolean,
    assureConjoint: AssureConjoint | null,
    isEnfants: boolean,
    assureEnfants: AssureEnfant[],
    dateEffet: string,
    telaRappeler: string,
    eMailRecontacte: string,
    paysNaissance: string,
    guidUser: string,
    pwdUser: string,
    ville: string,
    addressAssuree: string,
    addressComplement: string,
  ) {
    this.assurePrincipal = assurePrincipal;
    this.isConjoint = isConjoint;
    this.assureConjoint = assureConjoint;
    this.assureEnfants = assureEnfants;
    this.isEnfants = isEnfants;
    this.assureEnfants = assureEnfants;
    this.dateEffet = dateEffet;
    this.telaRappeler = telaRappeler;
    this.eMailRecontacte = eMailRecontacte;
    this.paysNaissance = paysNaissance;
    this.guidUser = guidUser;
    this.pwdUser = pwdUser;
    this.ville = ville;
    this.addressAssuree = addressAssuree;
    this.addressComplement = addressComplement;
  }
}

export interface AssurePrincipal {
  sexe: string;
  nom: string;
  prenom: string;
  dateNaissance: string;
  csp: string;
  regime: string;
  num_SS: string;
  orga: string; //Organisme d'affiliation
  noOrga: boolean; //Je transmettrai mon code organisme ultérieurement afin de bénéficier de la télétransmission
}

export interface AssureConjoint {
  sexe: string;
  nom: string;
  prenom: string;
  dateNaissance: string;
  csp: string;
  regime: string;
  num_SS: string;
  orga: string; //Organisme d'affiliation
  noOrga: boolean; //Je transmettrai mon code organisme ultérieurement afin de bénéficier de la télétransmission
}

export interface AssureEnfant {
  sexe: string;
  nom: string;
  prenom: string;
  dateNaissance: string;
  csp: string;
  regime: string;
  num_SS: string;
  orga: string; //Organisme d'affiliation
  noOrga: boolean; //Je transmettrai mon code organisme ultérieurement afin de bénéficier de la télétransmission
  rang: number;
  ayantDroit: boolean;
  ayantDroitDe: string;
}
